import {
  Box,
  Button,
  Divider,
  filter,
  Flex,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";

import _ from "lodash";
import { FC, useEffect, useMemo, useState } from "react";

import { aiScoresGroup, preferenceScoreGroup } from "config/Consts";

import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import SortIcon from "assets/sort-icon.svg";

import { useGetUserProfileQuery } from "queries";

import { useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import {
  defaultJobPayload,
  jobPayloadState,
  savedJobsSortByState,
  selectedSortByState,
} from "_state/atoms/AppAtoms";
import { OutlineButton, SecondaryButton } from "../HJSButton";

interface ISortByProps {
  protectedFeatures: string[];
}

interface IFilterState {
  data: any;
  // order: number[];
}
interface ISortBy {
  reset: boolean;
  setReset: (arg?: any) => void;
}

const FilterActions = {
  UP: "UP",
  DOWN: "DOWN",
};

const SortByMobile: FC = () => {
  const { data: userData } = useGetUserProfileQuery();
  const location = useLocation();
  const isJobSearch = location.pathname === "/jobs/search" || true;
  const [openSortByModal, setSortByModal] = useState<boolean>(false);
  const [payload, setPayload] = useRecoilState(jobPayloadState);

  const [reset, setReset] = useState<boolean>(false);

  const { aiScore, preferenceScore, postedDate, distance } = payload;
  const [isLargerThan600] = useMediaQuery("(min-width:600px)");
  // const countRef = useRef<number>(0);

  const sortByFilter = useMemo(() => {
    const filterArr = ["Location", "Posted Date"];
    // isJobSearch && filterArr.push("Date Posted");
    preferenceScoreGroup.includes(userData?.group) &&
      filterArr.unshift("Preference Score");
    aiScoresGroup.includes(userData?.group) && filterArr.unshift("AI Score");
    return filterArr;
  }, [userData]);

  const [order, setOrder] = useState<string[]>([]);

  const [filters, setFilters] = useState<IFilterState>({
    data: sortByFilter,
  });

  const [selectedSortBy, setSelectedSortBy] =
    useRecoilState(selectedSortByState);

  const [savedJobsSortBy, setSavedSortBy] =
    useRecoilState(savedJobsSortByState);

  useEffect(() => {
    if (reset) {
      setFilters(() => ({
        data: sortByFilter,
      }));
      setPayload({ ...defaultJobPayload, sort: sortByFilter });
      setOrder(sortByFilter);
    }
  }, [reset]);

  useEffect(() => {
    setFilters((prev) => ({
      data: sortByFilter,
      order: new Array(sortByFilter.length).fill(-1),
    }));
    setPayload((prev) => ({ ...prev, sort: [...sortByFilter] }));
    setOrder(sortByFilter);
  }, [sortByFilter]);

  // no  filter is on by default on saved job page
  // useEffect(() => {
  //   !isJobSearch && setSelectedSortBy([]);
  // }, []);

  // useEffect(() => {
  //   setOrder(sortByFilter);
  // }, [sortByFilter]);

  const handleFilterOrder = (action: string, filter: string): void => {
    const { UP, DOWN } = FilterActions;
    const newOrder = [...filters.data];
    const foundIdx = filters.data.indexOf(filter) as number;
    const prev = newOrder[foundIdx - 1];
    const next = newOrder[foundIdx + 1];

    reset && setReset(false);
    switch (action) {
      case UP:
        newOrder[foundIdx - 1] = filter;
        newOrder[foundIdx] = prev;
        // setOrder(newOrder);
        setFilters({ data: newOrder });
        break;
      case DOWN:
        newOrder[foundIdx + 1] = filter;
        newOrder[foundIdx] = next;
        // setOrder(newOrder);
        setFilters({ data: newOrder });
        break;
      default:
        break;
    }
  };

  const handleDone = (): void => {
    setPayload((prev) => ({ ...prev, sort: [...filters.data] }));
    setSortByModal(false);
  };

  const handleReset = (): void => {
    setFilters({ data: sortByFilter });
  };

  useEffect(() => {
    const { data } = filters;
    const temp = [...order];

    data?.forEach((el: any) => {
      !temp.includes(el) && temp.push(el);
    });
    setFilters({ data: temp });
    // order?.length > 0 && isJobSearch && setSelectedSortBy(temp);
  }, [order]);

  useEffect(() => {
    if (openSortByModal && (payload?.sort?.length ?? -1) > 0)
      setFilters({ data: payload?.sort });
  }, [openSortByModal]);
  return (
    <>
      <Box
        backgroundColor="teal.600"
        px={6}
        py="0.6rem"
        className="flex items-center gap-2 rounded-md justify-center"
        onClick={() => setSortByModal(true)}
        fontSize={14}
      >
        <img src={SortIcon} alt="sort-icon" />
        <Text color="white">SortBy</Text>
      </Box>
      <Modal
        isOpen={openSortByModal}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        onClose={() => {
          setSortByModal(false);
        }}
        isCentered={true}
        size={isLargerThan600 ? "md" : "xs"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Sort by</ModalHeader>
          <Divider borderColor="#2C7A7B" />
          <ModalCloseButton />

          <Box p={4}>
            <Text fontWeight={600} mb={2}>
              Sort by
            </Text>

            {filters?.data?.map((filter: string, index: number) => (
              <Box
                key={_.uniqueId("filter_")}
                onClick={() =>
                  !isJobSearch &&
                  !savedJobsSortBy.includes(filter) &&
                  setSavedSortBy((prev) => [...prev, filter])
                }
                className={`flex justify-between items-center ${
                  isJobSearch ? `cursor-[initial]` : `cursor-pointer`
                }`}
                py={4}
              >
                <Text fontSize={{ base: 14, md: 16 }} fontWeight="700">
                  {(index + 1).toString().concat(" - ")}
                  {filter}
                </Text>
                {isJobSearch && (
                  <Flex direction="column" alignItems="center">
                    {index > 0 && (
                      <ChevronUpIcon
                        className="cursor-pointer hover:bg-slate-300 rounded-lg"
                        onClick={() =>
                          handleFilterOrder(FilterActions.UP, filter)
                        }
                      />
                    )}
                    {index < filters?.data?.length - 1 && (
                      <ChevronDownIcon
                        className="cursor-pointer hover:bg-slate-300 rounded-lg"
                        onClick={() =>
                          handleFilterOrder(FilterActions.DOWN, filter)
                        }
                      />
                    )}
                  </Flex>
                )}
              </Box>
            ))}
            <Divider borderColor="#2C7A7B" mt={2} />
          </Box>
          <ModalFooter>
            <Button
              bg="rgba(0, 0, 0, 0.08)"
              color="teal.600"
              mr={3}
              px={6}
              py={2}
              fontSize={14}
              onClick={handleReset}
            >
              Reset
            </Button>
            <SecondaryButton
              colorScheme="teal.600"
              px={6}
              py={2}
              onClick={handleDone}
            >
              Done
            </SecondaryButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SortByMobile;
